import React from 'react';
import ChartSkeleton from './ChartSkeleton';
import ArrowChartSkeleton from './ArrowChartSkeleton';

const DepthChartSkeleton = () => {
  return (
    <div className='justify-center pb-8'>
      <ChartSkeleton />
      <div className="mt-4 mb-8 bg-gray-200 animate-pulse rounded-lg" style={{ height: '20px' }}>
      </div>
      <div className="flex flex-col md:flex-row md:items-center md:justify-center w-full">
        <div className="w-full md:w-1/2 p-2">
          <ArrowChartSkeleton />
        </div>
        <div className="w-full md:w-1/2 p-2">
          <div class="max-w-md mx-auto my-8">
            <table class="w-full text-sm text-center text-gray-600 bg-gray-200 animate-pulse">
              <thead>
                <tr class="text-xs uppercase">
                  <th class="py-2 px-4 opacity-0">Description</th>
                  <th class="py-2 px-4 opacity-0">Price</th>
                  <th class="py-2 px-4 opacity-0">Variation (%)</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="py-2 px-4 opacity-0">0Lswap MMP</td>
                  <td class="py-2 px-4 opacity-0">$0.003825</td>
                  <td class="py-2 px-4 opacity-0">-</td>
                </tr><tr>
                  <td class="py-2 px-4 opacity-0">0Lswap LTP</td>
                  <td class="py-2 px-4 opacity-0">$0.003880</td>
                  <td class="py-2 px-4 opacity-0 text-green-500">
                    <span class="text-green-500">▲ </span>1.44%
                  </td>
                </tr>
                <tr>
                  <td class="py-2 px-4 opacity-0">Osmosis LTP</td>
                  <td class="py-2 px-4 opacity-0">$0.004018</td>
                  <td class="py-2 px-4 opacity-0 text-green-500">
                    <span class="text-green-500">▲ </span>5.04%
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DepthChartSkeleton;
